import { render, staticRenderFns } from "./listAudit1.vue?vue&type=template&id=f12226ec"
import script from "./listAudit1.vue?vue&type=script&lang=js"
export * from "./listAudit1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports